import {
	AfterViewInit,
	ChangeDetectorRef,
	Component,
	ElementRef,
	EventEmitter, Input,
	NgZone, OnDestroy,
	OnInit,
	Output,
	ViewChild,
	ViewEncapsulation
} from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {LocalStorageService} from 'angular-2-local-storage';
import {SharedService} from '../../shared/shared.service';
import {LoggerService} from '../../logger/logger.service';
import {PaymentusService} from './paymentus.service';
import {DomSanitizer} from '@angular/platform-browser';
import {Http} from '@angular/http';
import {interval} from 'rxjs/observable/interval';
import {Subscription} from 'rxjs/Subscription';
import {Observable} from 'rxjs/Observable';
import {skip} from 'rxjs/operators';
import {fromEvent} from 'rxjs/observable/fromEvent';
import {PaymentusPaymentOptions} from './payment.options';
import {ManageCardsService} from '../manage-cards/manage-cards.service';
import {environment} from '../../../environments/environment';
import {conformToMask} from 'text-mask-core';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {timer} from 'rxjs/observable/timer';

@Component({
	selector: 'app-add-payment-method',
	templateUrl: './add-payment-method.component.html',
	styleUrls: ['./add-payment-method.component.css'],
	encapsulation: ViewEncapsulation.None
})
export class AddPaymentMethodComponent implements OnInit, OnDestroy {
	private authToken: string;
	protected iFrameUrl: string;
	protected frameHeight = 0;
	protected readonly PaymentusPaymentOptions = PaymentusPaymentOptions;
	src;

	@ViewChild('iframe') iframe: ElementRef;
	@Input() destroyInstance = false;
	@Input() showCancel = false;
	@Input() isEnrollment = false;
	billingAccountNumber: string;
	waitingFrameSubmission = false;
	closeFrame: BehaviorSubject<boolean> = new BehaviorSubject(false);

	paymentValidationIntervalId: number;

	paymentAdditionSubscription: Subscription;

	interval: Observable<number>;
	intervalSubscription: Subscription;
	closeFrameTimeoutSubscription: Subscription;
	frameLoadTimeoutSubscription: Subscription;
	private messageHandler: (evt: MessageEvent) => void;

	paymentProfiles: any[] = [];

	public panelOpenState = true

	storedToken: string;

	currentCategory: any;

	isLoadingFrame = true;
	isLoading = true;
	frameLoadFailed = false;

	frameLoadTimeout = timer(20000); // 20 seconds to render the CC iframe

	applePayPopup = undefined;

	@Output('onPaymentMethodRefresh') onPaymentMethodRefresh: EventEmitter<any> = new EventEmitter<any>();
	@Output('backOut') backOut: EventEmitter<any> = new EventEmitter<any>();

	public phoneMask = ['(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

	closeFrameTimeout = timer(1000 * 60 * 5); // 5 minutes

	constructor(
		private ngZone: NgZone,
		private router: Router,
		private sharedService: SharedService,
		private localStorageService: LocalStorageService,
		private paymentusService: PaymentusService,
		private logger: LoggerService,
		private activatedRoute: ActivatedRoute,
		private manageCardService: ManageCardsService
	) {
		let token: string = this.localStorageService.get('token');
		if (!token) {
			token = this.localStorageService.get('tempToken');
		}
		if (token) {
			this.storedToken = token;
			const methodName = this.constructor.name + '.verifyToken';
			this.sharedService.verifyToken({token})
				.then(res => {
					const logObj = {
						method: methodName,
						request: 'token : [masked]',
						response: res
					};
					this.logger.logInfo(JSON.stringify(logObj));
					this.isLoading = false;
					this.autoOpenCreditCardForEnrollment();
				});
		} else {
			this.isLoading = false;
			this.autoOpenCreditCardForEnrollment();
		}
		this.billingAccountNumber = this.localStorageService.get('account_number');
	}

	ngOnInit(): void {
		if (this.storedToken) {
			this.paymentusService.fetchPaymentProfiles(this.storedToken, true).then((resp) => {
				this.paymentProfiles = resp.profiles;
			});
		}

		this.closeFrame.subscribe((closeFrame) => {
			if (closeFrame && this.intervalSubscription) {
				this.intervalSubscription.unsubscribe();
			}
		})

		this.messageHandler = (evt: MessageEvent) => {
			this.ngZone.run(() => {
				this.receiveMessage(evt);
			});
		};
		window.addEventListener('message', this.messageHandler);

		if (this.isEnrollment && !this.isLoading) {
			this.autoOpenCreditCardForEnrollment();
		}
	}

	private autoOpenCreditCardForEnrollment() {
		if (!this.isEnrollment || this.currentCategory) {
			return;
		}
		const ccOption = PaymentusPaymentOptions.find((opt) => opt.key === 'debit-credit-card');
		if (ccOption) {
			this.onExpansionToggle(ccOption);
		}
	}

	ngOnDestroy() {
		if (this.messageHandler) {
			window.removeEventListener('message', this.messageHandler);
			this.messageHandler = undefined;
		}
		this.cancel();
	}

	cancel() {
		this.closeFrame.next(true);
		if (this.intervalSubscription) {
			this.intervalSubscription.unsubscribe();
			this.intervalSubscription = undefined;
		}
		if (this.closeFrameTimeoutSubscription) {
			this.closeFrameTimeoutSubscription.unsubscribe();
			this.closeFrameTimeoutSubscription = undefined;
		}
		this.clearFrameLoadTimeout();
		console.log('null interval')
		this.interval = undefined;
		this.backOut.emit(true)
	}

	isApple() {
		return /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform) || /(iPhone|iPod|iPad)/i.test(navigator.platform)
			|| navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
	}

	onExpansionToggle(event) {
		console.log(event)
		this.currentCategory = event.category;

		this.isLoadingFrame = this.currentCategory !== 'AP';
		this.frameLoadFailed = false;

		this.frameHeight = 0;

		if (this.isEnrollment && this.currentCategory !== 'AP') {
			this.startFrameLoadTimeout();
		}

		if (!this.isExpressPay()) {
			this.paymentusService.fetchAuthToken(this.storedToken, event.category)
				.then((resp) => {
					this.authToken = resp;
					this.iFrameUrl = `https://${environment.paymentusPrefix}.paymentus.com/xotp/pm/pogo?authToken=` + this.authToken;
					this.localStorageService.set('authToken', this.authToken);
				})
				.catch((err) => {
					this.handleFrameLoadFailure();
					this.logger.logError(JSON.stringify({ method: 'fetchAuthToken', error: err && err.message || err }));
				});
		} else {
			this.paymentusService.fetchAuthTokenForBan(this.billingAccountNumber, event.category)
				.then((resp) => {
					this.authToken = resp;
					this.iFrameUrl = `https://${environment.paymentusPrefix}.paymentus.com/xotp/pm/pogo?authToken=` + this.authToken;
					this.localStorageService.set('authToken', this.authToken);
				})
				.catch((err) => {
					this.handleFrameLoadFailure();
					this.logger.logError(JSON.stringify({ method: 'fetchAuthTokenForBan', error: err && err.message || err }));
				});
		}
	}

	private startFrameLoadTimeout() {
		if (this.frameLoadTimeoutSubscription) {
			this.frameLoadTimeoutSubscription.unsubscribe();
			this.frameLoadTimeoutSubscription = undefined;
		}
		this.frameLoadTimeoutSubscription = this.frameLoadTimeout.subscribe(() => {
			if (this.isLoadingFrame) {
				this.handleFrameLoadFailure();
				this.logger.logError(JSON.stringify({ method: 'frameLoadTimeout', error: 'Paymentus frame did not load within 20s' }));
			}
		});
	}

	private clearFrameLoadTimeout() {
		if (this.frameLoadTimeoutSubscription) {
			this.frameLoadTimeoutSubscription.unsubscribe();
			this.frameLoadTimeoutSubscription = undefined;
		}
	}

	handleFrameLoadFailure() {
		this.clearFrameLoadTimeout();
		this.isLoadingFrame = false;
		this.frameLoadFailed = true;
	}

	retryLoadFrame() {
		const ccOption = PaymentusPaymentOptions.find((opt) => opt.key === 'debit-credit-card');
		if (ccOption) {
			this.iFrameUrl = undefined;
			this.onExpansionToggle(ccOption);
		}
	}

	isExpressPay() {
		return this.localStorageService.get('is_express_pay');
	}

	public checkPaymentProfiles() {
		const token = this.storedToken;
		if (!token && !this.billingAccountNumber) {
			return;
		}
		const handleResp = (resp) => {
			if (resp.profiles && (!this.paymentProfiles || (this.paymentProfiles.length !== resp.profiles.length))) {
				this.paymentProfiles = resp.profiles;
				this.onPaymentMethodRefresh.emit(resp.profiles);
				this.waitingFrameSubmission = false;
				if (this.closeFrameTimeoutSubscription) {
					this.closeFrameTimeoutSubscription.unsubscribe();
					this.closeFrameTimeoutSubscription = undefined;
				}
				if (this.intervalSubscription) {
					this.intervalSubscription.unsubscribe();
					this.intervalSubscription = undefined;
				}
			}
		};
		if (!this.isExpressPay()) {
			this.paymentusService.fetchPaymentProfiles(token, true).then(handleResp);
		} else {
			this.paymentusService.fetchPaymentProfilesForBan(this.billingAccountNumber).then(handleResp);
		}
	}

	openApplePay() {
		this.applePayPopup = window.open(this.iFrameUrl, 'iframeTab', 'popup');
		this.applePayPopup.window.addEventListener('load', () => {
			this.applePayPopup.window.addEventListener('unload', () => {
				this.checkPaymentProfiles();
				window.location.reload()
			});
		});
	}

	receiveMessage(event) {
		const {data, origin} = event;
		if (!this.isPaymentusOrigin(origin) || this.currentCategory === 'AP') {
			return;
		}
		if (typeof data !== 'string') {
			return;
		}
		if (data.includes('frameHeight:')) {
			const frameHeight = data.split(':')[1];
			this.ngZone.run(() => {
				this.isLoadingFrame = false;
				this.frameLoadFailed = false;
				this.clearFrameLoadTimeout();
			});
			this.frameHeight = parseInt(frameHeight, 10) + 40; // 40 is the padding
			const container = document.getElementById('frame-container');
			if (container) {
				container.style.height = this.frameHeight + 'px';
			}
			if (!this.waitingFrameSubmission && !this.closeFrame.getValue() && !this.applePayPopup) {
				this.waitingFrameSubmission = true;
				if (!this.interval) {
					console.log('setting interval')
					this.interval = interval(10000); // 10 seconds
				}
				if (!this.intervalSubscription) {
					this.ngZone.run(() => {
						this.intervalSubscription = this.interval.subscribe(() => {
							if (this.closeFrame.getValue() || this.applePayPopup) {
								this.interval = undefined;
								return;
							}
							if (this.waitingFrameSubmission) {
								this.checkPaymentProfiles();
							}
						})
						this.closeFrameTimeoutSubscription = this.closeFrameTimeout.subscribe(() => {
							console.log('closing frame')
							this.cancel();
						})
					})
				}
			}
			return;
		}
		if (this.waitingFrameSubmission) {
			this.checkPaymentProfiles();
		}
	}

	private isPaymentusOrigin(origin: string): boolean {
		if (!origin || typeof origin !== 'string') {
			return false;
		}
		try {
			return new URL(origin).hostname.endsWith('.paymentus.com');
		} catch (_) {
			return false;
		}
	}

	backOutEmit() {
		this.backOut.emit();
	}
}



// WEBPACK FOOTER //
// ./src/app/payment/paymentus/add-payment-method.component.ts